import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { withRouter, Switch, Route } from 'react-router-dom';

import requiredSetupMappings from '../../../../components/required-setup-mappings';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';

import DashboardCurrentPage from '../DashboardCurrentPage/DashboardCurrentPage';
// import EnsureTeamSetup from './EnsureTeamSetup';

function DashboardPage() {
  return (
    <div>
      <Helmet title="Workspace" />
      <div className="container">
        <div className="clearfix">
          <h1 className="page-header">
            Workspace
          </h1>
        </div>
      </div>
      <Switch>
        <Route path="/workspace" component={DashboardCurrentPage} />
      </Switch>
    </div>
  );
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

DashboardPage.propTypes = {
};

DashboardPage.contextTypes = {
  router: PropTypes.object,
};
// export default EnsureTeamSetup(connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(DashboardPage), ['stage', 'dealType'])))));
export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(DashboardPage), ['stage', 'dealType']))));
